<template>
  <el-container class="sub-home">
    <el-header class="sub-header" style="padding: 0"
      ><swiper
        style="width: 100%; height: 100%; box-sizing: border-box"
        :options="swiperOptions"
      >
        <swiper-slide
          class="nav"
          v-for="i in RevMenuList"
          :key="i.menuCode"
          :index="i.menuCode"
        >
          <router-link class="nav-item" :to="{ name: i.menuCode }">{{
            i.menuName
          }}</router-link>
        </swiper-slide>
      </swiper></el-header
    >
    <el-main style="position: relative; padding: 0">
      <router-view></router-view
    ></el-main>
  </el-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["userInfo"]),
    RevMenuList() {
      if (
        this.userInfo.roleCodes.includes("projectGroupLeader") ||
        this.userInfo.roleCodes.includes("admin")
      ) {
        return this.researchGroupList;
      } else {
        return this.researchGroupList.filter(
          (u) => u.menuCode != "researchProjectMng"
        );
      }
    },
    researchGroupList() {
      if (
        this.userInfo.menuInfoList.find((u) => u.menuUrl == "researchProject")
      ) {
        return this.userInfo.menuInfoList.find(
          (u) => u.menuUrl == "researchProject"
        ).menuInfoList;
      } else {
        return [];
      }
    },
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: "auto",
        centeredSlides: false,
        observe: true,
      },
    };
  },
  created() {
    
  },
  methods: {},
  watch: {},
};
</script>
<style lang="less" scoped>
.sub-home {
  flex-direction: column;
  .sub-header {
    font-family: pfrgl;
    font-size: 16px;
    color: #666666;
    box-sizing: border-box;
    height: 36px !important;
    .nav {
      padding: 0 14px;
      width: auto;
      .nav-item {
        display: block;
        height: 100%;
        position: relative;
        &:after {
          display: block;
          content: "";
          height: 4px;
          width: 100%;
          bottom: 8px;
          position: absolute;
        }
      }
      .router-link-active {
        color: #1890ff;
        &::after {
          background: linear-gradient(90deg, #35c3ff 0%, #1890ff 100%);
        }
      }
    }
  }
}
</style>
